import "@babel/polyfill";
import { createApp } from "vue";
import App from "./app.vue";
import router from "./router";
import store from "./store";
import "jquery/src/jquery.js";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "@/assets/scss/custom.scss";
import api from "./interceptors";
import BootstrapVueNext from "bootstrap-vue-next";
import VueVirtualScroller from "vue-virtual-scroller";
import "./style.css";
import "animate.css";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VueApexCharts from "vue3-apexcharts";
import CKEditor from "@ckeditor/ckeditor5-vue";

createApp(App)
  .provide("$axios", api)
  .use(router)
  .use(BootstrapVueNext)
  .use(store)
  .use(VueVirtualScroller)
  .use(VueApexCharts)
  .use(CKEditor)
  .mount("#app");
